import { ProductSchedule, ProductScheduleItem } from '../../../../@types/model/productSchedule';
import { DeliveryRequestItem } from '../../../../@types/model/deliveryRequest';
import { DeliveryConfiguration } from '../../../../@types/model/deliveryConfiguration';
import { v4 as uuidv4 } from 'uuid';
import { RefactoredDevice } from '../../../../@types/model/device';

// Esta función devolverá el slot que deberíamos meter.
const addSlot = (
  device: RefactoredDevice,
  deliveryRequestItems: DeliveryRequestItem[],
  productSchedules: ProductSchedule[],
  deliveryConfiguration: DeliveryConfiguration | null
): DeliveryRequestItem | null => {
  // Primero buscamos el productSchedule que le corresponde.
  let deviceGuid = device.guid;
  if (device.attributes.is_ref_of && device.attributes.is_ref_of.split(':').length === 3) {
    deviceGuid = device.attributes.is_ref_of.split(':')[2];
  }
  let productSchedule = productSchedules.find((ps: ProductSchedule) =>
    ps.devices.includes(deviceGuid)
  );
  if (productSchedule && deliveryConfiguration) {
    let deliveryRequestItem: DeliveryRequestItem | null = null;
    let assigned = false;
    productSchedule.schedule.forEach((schedule: ProductScheduleItem) => {
      // Cuando hayamos encontrado y asignado saltamos.
      if (!assigned) {
        // Calcular el total de este ProductScheduleItem para ver si tenemos que seguir rellenando de este producto
        // La suma es lo ya consumido más los slots que hemos ido añadiendo de este producto en el carrito.
        let total = schedule.consumed;
        deliveryRequestItems.forEach((deliveryRequestItem: DeliveryRequestItem) => {
          if (
            deliveryRequestItem.productType === schedule.product &&
            deliveryRequestItem.productScheduleItem === schedule.guid
          ) {
            // Sólo sumamos si coincide el device, el tipo de producto que se ha añadido, y el paso de la crianza.
            total += deliveryRequestItem.quantity;
          }
        });
        // Si el total, es menor a la cantidad de este paso de crianza, quiere decir que debemos introducir más cantidad en este silo de este paso de crianza.
        if (total < schedule.quantity) {
          // Debemos comprobar cuanta cantidad añadir. Ya que si el máximo por slot es 2000, y podemos meter 3000, deberíamos meter solo 2000.
          let quantity_to_insert = schedule.quantity - total;
          if (quantity_to_insert > deliveryConfiguration.configuration.slot_amount) {
            quantity_to_insert = deliveryConfiguration.configuration.slot_amount;
          }
          deliveryRequestItem = {
            device: deviceGuid,
            guid: uuidv4(),
            quantity: quantity_to_insert,
            device_data: device,
            productType: schedule.product,
            productScheduleItem: schedule.guid,
            productScheduleItemOrdinal: schedule.ordinal
          } as DeliveryRequestItem;
          assigned = true;
        }
      }
    });
    if (deliveryRequestItem) return deliveryRequestItem as DeliveryRequestItem;
    else return null;
  } else {
    return null;
  }
};

export default addSlot;
